import { render, staticRenderFns } from "./userItem.vue?vue&type=template&id=bfa8ea00&scoped=true&lang=pug"
import script from "./userItem.vue?vue&type=script&lang=js"
export * from "./userItem.vue?vue&type=script&lang=js"
import style0 from "./userItem.vue?vue&type=style&index=0&id=bfa8ea00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa8ea00",
  null
  
)

export default component.exports